import { render, staticRenderFns } from "./AppraisalRiskDrillDown2.vue?vue&type=template&id=320a6530&"
import script from "./AppraisalRiskDrillDown2.vue?vue&type=script&lang=ts&"
export * from "./AppraisalRiskDrillDown2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports